import{AxiosProcessor} from '../../shared/axios/AxiosProcessor';
const urlEmployee = '/employee';

const state = {
    employee: {},
    employees:[],
    employeeDetails: {},
    employeesPageKey:{}
};

const getters = {
    getEmployee: state => {
        return state.employee;
    },
    getEmployees: state => {
        return state.employees;
    },
    getEmployeeDetails: state => {
        return state.employeeDetails;
    },
    getEmployeesPageKey : state => {
        return state.employeesPageKey;
    }
};

const mutations = {
    setEmployee: (state, data) => {
        state.employee = data;
    },
    setEmployees: (state, data) => {
        state.employees = data;
    },
    setEmployeeDetails: (state, data) => {
        state.employeeDetails = data;
    },
    setEmployeesPageKey: (state, data) => {
        state.employeesPageKey = data;
    }
};

const actions = {
    async setEmployee ({commit}, data) {
        let value = {};

        if(data.id) {
            value = await AxiosProcessor.put(urlEmployee+'/'+ data.id, data);
        }
        else {
            value = await AxiosProcessor.post(urlEmployee, data);
        }

        commit('setEmployee', value);
        //updated the list as well
        if (state.employees.length > 0){
            let employee  = state.employees.find(emp => emp.id === value.id);
            employee = JSON.parse(JSON.stringify(value));
            commit('setEmployees', state.employees);
        }
    },
    async getEmployee ({commit}, data) {
        let id = data.id;

        if (!id)
            throw {message: 'empty id. Please provide a valid id value 123123'};

        /**
         * First we check the state
         * then we check the list
         * then we go to backend
         */
        if(state.employee.id && state.employee.id === id)
            return;

        let employee;
        let value = {};

        if (state.employees.length > 0)
            employee  = state.employees.find(emp => emp.id === id);

        if(employee)
        {
            value = employee;
        }
        else
        {
            let response = await AxiosProcessor.get(urlEmployee+'/'+id);

            if(response.Item)
                value = response.Item;
        }

        commit('setEmployee', value);
    },
    async getEmployees ({commit},data = null) {

        let value = [];
        let response = await AxiosProcessor.list(urlEmployee,data);

        if(response.Items)
            value = response.Items;

        commit('setEmployees', value);
    },
    async getEmployeeDetails ({commit}, data) {
        let value = {};
        let response = await AxiosProcessor.get('/counter/employee');
        if(response.Item)
            value = response.Item;

       commit('setEmployeeDetails', value);
    },
    async deleteEmployee ({commit}, data) {
        let value = await AxiosProcessor.delete(urlEmployee+'/'+data.id);

        commit('setEmployee', value);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}